import { AppPlatform } from '@contexts/app/AppPlatform';
import {
    AndroidWebviewULRpcCaller,
    DefaultULRpcCaller,
    IOSWebviewULRpcCaller,
    PostMessageULRpcCaller,
} from '@services/rpcCaller';
import { ReactNativeWebviewULRpcCaller } from '@services/rpcCaller/ReactNativeWebViewRpcCaller';

export const getRpcCaller = (
    platform: AppPlatform,
    rpcId: string,
    iframeMode: boolean,
    parentWhitelistedOrigin: string = '',
    useExactUrl: boolean = false
) => {
    switch (platform) {
        case AppPlatform.IOS:
            return new IOSWebviewULRpcCaller(rpcId, window);
        case AppPlatform.ANDROID:
            return new AndroidWebviewULRpcCaller(rpcId, window);
        case AppPlatform.ReactNative:
            return new ReactNativeWebviewULRpcCaller(rpcId, window);
        default:
            return iframeMode
                ? new PostMessageULRpcCaller(rpcId, window.parent, window, parentWhitelistedOrigin, useExactUrl)
                : new DefaultULRpcCaller(rpcId);
    }
};
